import { ObjectActionCommandMenu } from "@/object-actions/renderers/ObjectActionCommandMenu";
import { useObjectActions } from "@/object-actions/renderers/useObjectActions";
import type { ObjectActionHandlers } from "@/object-actions/types";
import type { NodeContextMenuCursorPosition } from "./CanvasNodeContextMenu";

interface CanvasEdgeContextMenuProps {
  cursorPosition: NodeContextMenuCursorPosition;
  onClose: () => void;
  handlers: ObjectActionHandlers;
  /** A side is pinned or the route is drawn by hand, so Route automatically applies. */
  routeCustomised: boolean;
  canEdit: boolean;
}

/**
 * The edge's right-click menu — the same menu its toolbar's More opens, built
 * from the `canvas-edge` manifest so it reads like the connector's: order,
 * routing, then the destructive tail.
 */
export function CanvasEdgeContextMenu({
  cursorPosition,
  onClose,
  handlers,
  routeCustomised,
  canEdit,
}: CanvasEdgeContextMenuProps) {
  const kind = { type: "canvas-edge" } as const;
  const { actions } = useObjectActions({
    kind,
    surface: "context-menu",
    scope: "canonical",
    state: { canEdit, zOrderDisabled: false, routeCustomised },
    handlers,
  });

  return (
    <ObjectActionCommandMenu
      cursorPosition={cursorPosition}
      actions={actions}
      kind={kind}
      onClose={onClose}
    />
  );
}
